export default function LandingPage() {
  return (
    <div className="bg-charcoal text-offwhite min-h-screen">
      {/* Hero Section */}
      <div className="text-center py-20 px-6 max-w-3xl mx-auto">
        <h1 className="text-4xl md:text-5xl font-bold mb-4">
          Build & Run Autonomous AI Agents Instantly
        </h1>
        <p className="text-lg text-gray-400 mb-6">
          CortexRuntime is your all-in-one sandbox for AI agents with memory,
          tools, and workflows. No setup, no stress.
        </p>
        <a
          href="/runtime"
          className="bg-teal hover:bg-teal/80 px-6 py-3 rounded-lg text-offwhite font-semibold transition"
        >
          Launch Runtime
        </a>
      </div>

      {/* How It Works */}
      <div className="py-20 bg-secondary px-6">
        <h2 className="text-2xl font-bold text-center mb-10 text-offwhite">
          How It Works
        </h2>
        <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
          <div>
            {/* <div className="text-3xl mb-2">🧠</div> */}
            <h3 className="font-semibold text-lg mb-2 text-offwhite">
              Create an Agent
            </h3>
            <p className="text-gray-400">
              Define its name, model, tags, and prompt — no code required.
            </p>
          </div>
          <div>
            {/* <div className="text-3xl mb-2">💬</div> */}
            <h3 className="font-semibold text-lg mb-2 text-offwhite">
              Chat & Iterate
            </h3>
            <p className="text-gray-400">
              Send tasks, receive responses, and evolve the agent's memory.
            </p>
          </div>
          <div>
            {/* <div className="text-3xl mb-2">📚</div> */}
            <h3 className="font-semibold text-lg mb-2 text-offwhite">
              Explore & Fork
            </h3>
            <p className="text-gray-400">
              Browse the agent library and fork public agents into your
              workspace.
            </p>
          </div>
        </div>
      </div>

      {/* Features */}
      <div className="py-20 px-6 max-w-5xl mx-auto">
        <h2 className="text-2xl font-bold text-center mb-10 text-offwhite">
          Features
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div>
            <h3 className="font-semibold text-lg text-offwhite">
              Persistent Memory
            </h3>
            <p className="text-gray-400">
              Every agent has a searchable long-term memory stored via
              embeddings.
            </p>
          </div>
          <div>
            <h3 className="font-semibold text-lg text-offwhite">
              Pro Access Control
            </h3>
            <p className="text-gray-400">
              Limit features, fork agents, and manage access tiers via Paystack
              payments.
            </p>
          </div>
          <div>
            <h3 className="font-semibold text-lg text-offwhite">
              Agent Library
            </h3>
            <p className="text-gray-400">
              Explore and fork powerful prebuilt agents with shared prompts and
              tools.
            </p>
          </div>
          <div>
            <h3 className="font-semibold text-lg text-offwhite">
              Session Logs
            </h3>
            <p className="text-gray-400">
              Each agent interaction is saved with memory and session title
              summarization.
            </p>
          </div>
        </div>
      </div>

      {/* Pricing */}
      <div className="bg-secondary py-20 px-6 text-center">
        <h2 className="text-2xl font-bold mb-6 text-offwhite">Pricing</h2>
        <p className="text-gray-400 mb-6">
          Start free, upgrade once for lifetime Pro access.
        </p>
        <div className="inline-block text-left bg-charcoal p-6 rounded-xl shadow-sm">
          <p className="font-semibold text-offwhite text-lg">
            Pro Plan – $15* one-time
          </p>
          <ul className="text-gray-400 mt-4 list-disc list-inside text-sm space-y-1">
            <li> Unlimited Agents</li>
            <li> Full Memory Access</li>
            <li> Semantic Search</li>
            <li> Agent Forking</li>
          </ul>
          <a
            href="/library"
            className="mt-4 block bg-teal hover:bg-teal/80 text-offwhite text-center py-2 rounded-lg transition"
          >
            Upgrade Now
          </a>
        </div>
      </div>

      {/* Footer */}
      <div className="text-center text-sm text-gray-400 py-8 bg-charcoal">
        *Amount will be converted to ZAR for Paystack payments.
      </div>
      <div className="text-center text-sm text-gray-400 py-8 bg-charcoal">
        © {new Date().getFullYear()} CortexRuntime — Built for agent-powered
        workflows.
      </div>
    </div>
  );
}
